module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8n3n6r-34434adbec3098d6fd4199fbb3390650.svg";